import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {Shopify} from "@/services/storage/Shopify";
import {Pixel} from "@/services/storage/Pixel";
import {Debug} from "@/services/storage/Debug";


export class Storage extends AbstractStorageModule {
  shopify = new Shopify();
  pixel = new Pixel();
  debug = new Debug();
}



